import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, } from "react-router-dom";
import { Card, CardBody, Input, Table } from "reactstrap";
import { Pager } from ".";
import { api, constants } from "../utils";
import { ItemDropdownMenu, ServiceThreadSpinner } from "./";
const { ENDPOINTS } = constants;

export default function InventoryDashBoardWhereUsed({ ...props }) {
   const navigate = useNavigate();
   const [componentNumber, setComponentNumber] = useState(props.componentNumber);
   const [loaded, setLoaded] = useState(false);
   const [page, setPage] = useState(1);
   const [pageSize, setPageSize] = useState(25);
   const [showDiscontinued, setShowDiscontinued] = useState(false);
   const [whereUsedItems, setWhereUsedItems] = useState([]);
   const [totalPages, setTotalPages] = useState();

   useEffect(() => {
      if (componentNumber !== props.componentNumber) {
         setComponentNumber(props.componentNumber);
      }
   }, [componentNumber, props.componentNumber]);

   useEffect(() => {
      if (!props.componentNumber) return;
      setLoaded(false);
      getWhereUsed();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [page, pageSize, componentNumber, showDiscontinued]);

   function getWhereUsed() {
      return api
         .post("Inventory/GetPaginatedWhereUsed", {
            ItemNumber: componentNumber,
            ShowDiscontinued: showDiscontinued,
            PageNumber: page,
            PageSize: pageSize,
         })
         .then((response) => {
            if (response.data.success) {
               // setWhereUsedComponent(componentNumber);
               setWhereUsedItems(response?.data?.whereUsed?.items);
               setTotalPages(
                  _.ceil(response?.data?.whereUsed?.totalCount / pageSize)
               );
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));
   }

   function updatePageSize(size) {
      setPageSize(size);
      setPage(1);
   }

   return (
      <>
         <Card className="dashboard-card">
            <CardBody>
               <div>
                  <span className="h2" style={{ display: "inline" }}>Where Used</span>
                  {/* <span className="text-muted">Customer {customerI}</span> */}
                  <div className="float-end InLineAttributes">
                     <div>
                        <Input
                           type="checkbox"
                           defaultChecked={false}
                           value={showDiscontinued}
                           onChange={() => setShowDiscontinued(!showDiscontinued)}
                        />
                        {" "}
                        <span style={{ marginLeft: "10px" }}>Show Discontinued Items?</span>
                     </div>
                  </div>
               </div>
               <hr />
               <ServiceThreadSpinner on={!loaded}>
                  {whereUsedItems && whereUsedItems.length ? (
                     <>
                        <Table size="sm" className="data-table">
                           <thead className="table-header">
                              <tr>
                                 <th>Item</th>
                                 <th>On Order</th>
                                 <th>Edit BOM</th>
                              </tr>
                           </thead>
                           <tbody>
                              {_.map(whereUsedItems, (c, index) => (
                                 <tr key={index}>
                                    <ItemDropdownMenu
                                       itemNumber={c.itemNumber}
                                       itemDescription={c.itemWithDesc}
                                       attachmentCount={c.itemAttachmentCount}
                                    />
                                    <td className="boldedOrange"
                                       style={{ cursor: "pointer" }}
                                       onClick={() => navigate(
                                          `${constants.ENDPOINTS.productionPlanningForSpecifiedItem}/${c.itemNumber}`,
                                          {
                                             state: {
                                                label: c.itemNumber,
                                                value: c.itemNumber,
                                             },
                                             replace: true,
                                          }
                                       )}
                                    >
                                       {Math.round(c.qtyOnOrder).toLocaleString()}
                                    </td>
                                    <td
                                       className="boldedOrange"
                                       style={{ cursor: "pointer" }}
                                       onClick={() => navigate(ENDPOINTS.bomComponents, { state: { label: c.itemWithDesc, value: c.itemNumber } })}
                                    >
                                       Edit BOM
                                    </td>
                                 </tr>
                              ))}
                           </tbody>
                        </Table>
                        <Pager
                           callBack={setPage}
                           sizeCallback={updatePageSize}
                           pageNumber={page}
                           pageSize={pageSize}
                           totalPages={totalPages}
                           className={"float-start justify-content-center"}
                        />
                     </>
                  ) : (
                     <div>
                        <span>No Where Used Info Found</span>
                     </div>
                  )}
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </>
   );
}
